import { render, staticRenderFns } from "./mobile.vue?vue&type=template&id=77a10657&scoped=true&"
import script from "./mobile.vue?vue&type=script&lang=js&"
export * from "./mobile.vue?vue&type=script&lang=js&"
import style0 from "./mobile.vue?vue&type=style&index=0&id=77a10657&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a10657",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/FooterNavigation/mobile.vue
// module id = null
// module chunks = 